<app-start *ngIf="!gameHasStarted"></app-start>
<app-game *ngIf="gameHasStarted">

</app-game>
  <!-- <button (click)="startGame()">
    Start Game:
  </button> -->
<!-- <audio controls autoplay loop>
  <source src="./../assets/Theme.mp3" type="audio/mp3">
</audio> -->